module.exports = __webpack_public_path__ + "static/sap-1bd3da1d20f714eaa376ce0fbbc38f1d.png";